import api from "@/api/axios";
import {
  AuthResponse,
  ChangePasswordPayload,
  SignupPayload,
  AuthUser,
} from "@/types/auth";
import { ApiResponse } from "@/types/apiResponse";

export async function fetchSignUp(payload: SignupPayload) {
  const res = await api.post<ApiResponse<AuthResponse>>(
    "/auth/signup",
    payload
  );

  return res.data.data;
}

export async function fetchLogin(email: string, password: string) {
  const res = await api.post<ApiResponse<AuthResponse>>("/auth/login", {
    email: email,
    password: password,
  });

  return res.data.data;
}

export async function fetchLogout() {
  await api.post("/auth/logout");
}

export async function fetchUserInfo(signal: AbortSignal) {
  const res = await api.get<ApiResponse<AuthUser>>("/user/info", {
    signal: signal,
  });

  return res.data.data;
}

export async function fetchForgotPassword(email: string) {
  await api.post(`/auth/forgot-password/`, { email: email });
}

export async function fetchChangePassword(payload: ChangePasswordPayload) {
  const res = await api.patch(`/auth/change-password/`, payload);

  return res.status;
}

export async function fetchConfirmEmail(email: string, token: string) {
  const res = await api.patch(`/auth/confirm-email/`, {
    email: email,
    token: token,
  });

  return res.status;
}
